/**
 * Faturamento
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {DashboardCollection} from '@/model/collection/DashboardCollection'

export class Dashboard extends Resource {
  idAdmDashboardPk: number = 0

  qtdEntregadores: number | null = null
  qtdNotasInseridasApp: number | null = null
  qtdNotasInseridasPainel: number | null = null
  qtdNotasInseridasIntegracao: number | null = null
  qtdNotasFinalizadasApp: number | null = null
  qtdNotasFinalizadasPainel: number | null = null
  qtdNotasFinalizadasIntegracao: number | null = null
  qtdNotasCanceladas: number | null = null
  qtdSmsDisparado: number | null = null
  qtdResponsaveis: number | null = null
  qtdResponsaveisUltimos30Dias: number | null = null
  qtdEmailDisparado: number | null = null
  qtdAcessoPortalCliente: number | null = null
  qtdConsultasRoveriNota: number | null = null
  qtdConsultasRoveriCnpj: number | null = null
  dataGeracao: number | null = null

  month: number | null = null

  get $id() {
    return this.idAdmDashboardPk
  }
  set $id(val) {
    this.idAdmDashboardPk = val
  }

  get calculoNotasFinalizadas() {
    return (
      (this.qtdNotasFinalizadasApp ?? 0) +
      (this.qtdNotasFinalizadasPainel ?? 0) +
      (this.qtdNotasFinalizadasIntegracao ?? 0)
    )
  }

  get totalNotasFinalizadas() {
    return this.month != null ? this.calculoNotasFinalizadas : null
  }

  get calculoNotasInseridas() {
    return (
      (this.qtdNotasInseridasApp ?? 0) +
      (this.qtdNotasInseridasPainel ?? 0) +
      (this.qtdNotasInseridasIntegracao ?? 0)
    )
  }

  get totalNotasInseridas() {
    return this.month != null ? this.calculoNotasInseridas : null
  }

  /**
   * Lists the instances of Dashboard
   */
  static async listDashboard(params: any) {
    return await Request.get(`/admin/dashboard`, {params})
      .name('listDashboard')
      .as(DashboardCollection)
      .getData()
  }

  /**
   * Lists the instances of Dashboard
   */
  static async listFaturamentoAnnually(params: any) {
    return await Request.get(`/admin/dashboard/annually`, {params})
      .name('listDashboard')
      .as(DashboardCollection)
      .getData()
  }

  /**
   * Lists the instances of Dashboard to use it in a CSV file
   */
  static async listCsvDashboard(params: any) {
    return await Request.get(`/admin/dashboard/csv`, {params})
      .name('listCsvDashboard')
      .as(DashboardCollection)
      .getData()
  }

  static async getLastGenerationDate() {
    return await Request.get(`/admin/dashboard/get-last-generation-date`)
      .name('getLastGenerationDate')
      .asString()
      .getData()
  }

  static async listAvailableYears() {
    return await Request.get(`/admin/dashboard/get-available-years`)
      .name('getAvailableYears')
      .asArrayOf(String)
      .getData()
  }
}
